import React from 'react';
import { getLiftClass, getLiftColor, getLiftStatusColors } from "../../helpers/map";
import LabelLift from "../UI/LabelLift";
import LiftLabelTypeSeat from "./components/LiftLabelTypeSeat";
import LiftLine from "./components/LiftLine";

const Lift8 = ({ isOpen, state, activeLiftId }) => {
	const colors = getLiftColor(isOpen, state);
	return (
		<g id="Lift8"
			 className={getLiftClass(isOpen, activeLiftId === '8', state)}
			 transform="translate(1905.000000, 649.000000)"
		>
			<LiftLine x1="94.5" y1="89.5" x2="248" y2="208.932152" color={colors[0]}/>

			<LiftLabelTypeSeat
				seatCount="4"
				isOpen={isOpen}
				colors={getLiftStatusColors(state, isOpen)}
				coords="108.000000, 97.694374"/>

			<LiftLine x1="12.5" y1="13.5" x2="64.5" y2="60.5" color={colors[0]}/>

			<LabelLift isOpen={isOpen} text={<tspan x="0.5" y="13.5">8</tspan>}/>

			<g id="Labe-lift"
				 transform="translate(257.000000, 216.000000) rotate(-8.000000) translate(-257.000000, -216.000000) translate(244.000000, 203.000000)">
				<circle fill={colors[1]} fillRule="evenodd" cx="13" cy="13" r="13"/>
				<circle fill="#FFFFFF" fillRule="evenodd" cx="13" cy="13" r="10"/>
			</g>

			<polygon
				fill={colors[2]}
				transform="translate(256.488509, 215.614564) scale(-1, 1) rotate(-216.000000) translate(-256.488509, -215.614564) "
				points="250.988509 215.614564 261.988509 210.114564 259.617022 215.614564 261.988509 221.114564"/>
		</g>
	);
};

export default Lift8;
